var map = {
	"./nfgspeaking/notable-speaker-demo.json": 847,
	"./nfgspeaking2/nsf_1.1_Thunberg.json": 736,
	"./nfgspeaking2/nsf_1.2_Lewinsky.json": 472,
	"./nfgspeaking2/nsf_2.1_Bush.json": 756,
	"./nfgspeaking2/nsf_2.2_Markle.json": 26,
	"./nfgspeaking2/nsf_2.3_Wahls.json": 388,
	"./nfgspeaking2/nsf_2.4_Yousafzai.json": 112,
	"./nfgspeaking2/nsf_3.3_Wernicke.json": 768,
	"./nfgspeaking2/nsf_3.5_Cain.json": 94,
	"./nfgspeaking2/nsf_4.1_Abdel-Magied.json": 590,
	"./nfgspeaking2/nsf_4.2_Raskopoulos.json": 855,
	"./nfgspeaking2/nsf_4.4_Hsueh.json": 913,
	"./nfgspeaking2/nsf_5.2_Pierson.json": 47,
	"./nfgspeaking2/nsf_5.3_Martin.json": 143,
	"./nfgspeaking2/nsf_6.2_Soneji.json": 777,
	"./nfgspeaking2/nsf_6.3_Epstein.json": 424,
	"./nfgspeaking2/nsf_7.3_Finley.json": 180
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 784;